// components/ExamLoader.jsx
export default function ExamLoader({ message = "Loading exam…" }) {
  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.spinner} />
        <div style={styles.text}>{message}</div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: "100vh",
    minWidth: "100vw",
    display: "grid",
    placeItems: "center",
    background: "#f6f7f9"
  },
  card: {
    background: "#fff",
    padding: "28px 32px",
    borderRadius: 10,
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16
  },
  text: {
    fontSize: 16,
    color: "#444"
  },
  spinner: {
    width: 36,
    height: 36,
    border: "4px solid #e0e0e0",
    borderTopColor: "#555",
    borderRadius: "50%",
    animation: "spin 1s linear infinite"
  }
};
